import { createContext, useState } from "react";

export const ProdutosMotoristaContext = createContext({});

export function ProdutosProvider({ children }) {
  const [itensContrapartida, setItensContrapartida] = useState([]);

  return (
    <ProdutosMotoristaContext.Provider
      value={{
        itensContrapartida,
        setItensContrapartida,
      }}
    >
      {children}
    </ProdutosMotoristaContext.Provider>
  );
}
